module.exports = __webpack_public_path__ + "img/223456.7f9ee1a3.png";